module.exports = __webpack_public_path__ + "img/logout.6ae68afc.svg";